(() => {
  const init = () => document.querySelectorAll('[data-lifty-labs-setup]').forEach(group => {
    if (group.dataset.initialized) return;
    const form = document.getElementById(group.dataset.productFormId);
    if (!form || form.tagName !== 'FORM') return;
    group.dataset.initialized = 'true';
    const inputs = Array.from(group.querySelectorAll('[data-labs-weather]'));
    const choices = group.querySelector('[data-labs-choices]');
    const selected = () => inputs.find(input => input.checked);
    const clubInputs = [...group.querySelectorAll('[data-labs-club]')];
    const clubSelected = () => clubInputs.find(input => input.checked);
    const requestInputs = [...group.querySelectorAll('[data-labs-request]')];
    const requested = () => requestInputs.filter(input => input.checked && input.value);
    const tabs = [...group.querySelectorAll('[data-labs-tab]')];
    const activate = tab => {
      tabs.forEach(item => {item.setAttribute('aria-selected', String(item === tab)); item.tabIndex = item === tab ? 0 : -1;});
      group.querySelectorAll('[data-labs-panel]').forEach(panel => panel.hidden = panel.dataset.labsPanel !== tab.dataset.labsTab);
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) {event.preventDefault(); activate(tabs[next]); tabs[next].focus();}
      });
    });
    const requestProperty = document.createElement('input');
    requestProperty.type = 'hidden';
    requestProperty.name = 'properties[Upgrade quote request — not charged]';
    requestProperty.disabled = true;
    form.append(requestProperty);
    const status = group.querySelector('[data-labs-status]');
    const section = group.closest('[data-lifty-product-section]');
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-IE', {style: 'currency', currency: group.dataset.currency || 'EUR'});
    let busy = false;
    const update = () => {
      const variant = form.querySelector('[name="id"]');
      const base = variant?.selectedOptions?.[0]?.dataset.priceCents || group.dataset.basePrice;
      group.querySelector('[data-labs-total]').textContent = formatter.format((Number(base) + Number(selected()?.dataset.price || 0) + Number(clubSelected()?.dataset.price || 0)) / 100);
      const requests = requested();
      requestProperty.value = requests.map(input => input.value).join('; ');
      requestProperty.disabled = !requests.length;
      group.querySelector('[data-labs-request-summary]').hidden = !requests.length;
      group.querySelector('[data-labs-request-total]').textContent = formatter.format(requests.reduce((sum, input) => sum + Number(input.dataset.price || 0), 0) / 100);
      const enquiry = group.querySelector('[data-labs-enquiry]');
      enquiry.href = `mailto:hello@lifty.co?subject=${encodeURIComponent('Lifty Labs setup / ' + group.dataset.productTitle)}&body=${encodeURIComponent(group.dataset.productTitle + '\n' + window.location.origin + window.location.pathname + '\nRequested upgrades: ' + (requestProperty.value || 'Please advise on compatible options') + '\nPlease confirm exact part fitment, included components and final fitted price.')}`;
      status.hidden = true;
    };
    if (choices) choices.disabled = false;
    group.querySelectorAll('[data-labs-interactive]').forEach(fieldset => fieldset.disabled = false);
    [...inputs, ...clubInputs, ...requestInputs].forEach(input => input.addEventListener('change', update));
    form.addEventListener('change', update);
    section?.querySelector('[data-b2w-open]')?.addEventListener('click', () => {
      const tier = selected()?.dataset.tier || 'none';
      const input = section.querySelector(`input[name="b2w_weatherproof"][value="${tier}"]`);
      if (input && !input.disabled) { input.checked = true; input.dispatchEvent(new Event('change', {bubbles: true})); }
    }, true);
    section?.addEventListener('submit', async event => {
      const extraItems = window.LiftyRide?.cartExtras?.() || [];
      if (event.target !== form || (!selected()?.value && !clubSelected()?.value && !extraItems.length)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (busy) return;
      busy = true;
      const button = form.querySelector('[type="submit"]');
      const originalText = button?.textContent;
      const paidChoices = [selected(), clubSelected()].filter(input => input?.value);
      const data = new FormData(form);
      const quantity = Math.max(1, Math.floor(Number(data.get('quantity')) || 1));
      const properties = {};
      data.forEach((value, key) => { if (key.startsWith('properties[')) properties[key.slice(11, -1)] = value; });
      const setupId = crypto.randomUUID();
      properties._lifty_setup = setupId;
      const items = [
        {id: Number(data.get('id')), quantity, properties},
        ...paidChoices.map(choice => ({id: Number(choice.value), quantity, properties: {'For vehicle': group.dataset.productTitle, _lifty_setup: setupId, _lifty_service: choice.hasAttribute('data-labs-club') ? 'membership' : 'weatherproofing'}})),
        ...extraItems.map(item => ({...item, quantity, properties: {...item.properties, _lifty_setup: setupId}}))
      ];
      if (data.get('selling_plan')) items[0].selling_plan = data.get('selling_plan');
      status.hidden = true;
      if (button) {button.disabled = true; button.textContent = group.dataset.adding;}
      if (choices) choices.disabled = true;
      clubInputs.forEach(input => {input.dataset.wasDisabled = String(input.disabled); input.disabled = true;});
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items})});
        const result = await response.json();
        if (!response.ok || result.status) throw new Error('cart');
        window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
      } catch (error) {
        status.textContent = group.dataset.error;
        const link = document.createElement('a');
        link.href = `${window.Shopify?.routes?.root || '/'}cart`;
        link.textContent = ' → ' + group.dataset.cartLabel;
        status.append(link);
        status.hidden = false;
        if (button) {button.disabled = false; button.textContent = originalText;}
        if (choices) choices.disabled = false;
        clubInputs.forEach(input => input.disabled = input.dataset.wasDisabled === 'true');
        busy = false;
      }
    }, true);
    update();
  });
  init();
  document.addEventListener('shopify:section:load', init);
})();

